export default __webpack_public_path__ + "static/media/8.b21ae078.webp";